import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UIUtil } from '../utils/ui.util';
import { session_keys } from '..';

@Injectable({
  providedIn: 'root'
})
export class AfterLoginGuard implements CanActivate {
  constructor(private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (UIUtil.getPrivateData(session_keys.private_key).email) {
      // logged in so return true.....
      this.router.navigate(['view']);
      return true;
    }
    return true;
  }
}
